module.exports = __webpack_public_path__ + "img/bolt-lightning.9fd516bc.svg";